export default __webpack_public_path__ + "static/media/elevate-dmb-banner-1.a0786e3d.jpg";